import _slicedToArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { QueryBuilder } from "./QueryBuilder";
import { InsertResult } from "./result/InsertResult";
import { ReturningStatementNotSupportedError } from "../error/ReturningStatementNotSupportedError";
import { InsertValuesMissingError } from "../error/InsertValuesMissingError";
import { ReturningResultsEntityUpdator } from "./ReturningResultsEntityUpdator";
import { BroadcasterResult } from "../subscriber/BroadcasterResult";
import { TypeORMError } from "../error";
import { v4 as uuidv4 } from "uuid";
import { DriverUtils } from "../driver/DriverUtils";
import { ObjectUtils } from "../util/ObjectUtils";
import { InstanceChecker } from "../util/InstanceChecker";
/**
 * Allows to build complex sql queries in a fashion way and execute those queries.
 */
export var InsertQueryBuilder = /*#__PURE__*/function (_QueryBuilder) {
  _inherits(InsertQueryBuilder, _QueryBuilder);
  var _super = _createSuper(InsertQueryBuilder);
  function InsertQueryBuilder() {
    var _this;
    _classCallCheck(this, InsertQueryBuilder);
    _this = _super.apply(this, arguments);
    _this["@instanceof"] = Symbol.for("InsertQueryBuilder");
    return _this;
  }
  // -------------------------------------------------------------------------
  // Public Implemented Methods
  // -------------------------------------------------------------------------
  /**
   * Gets generated SQL query without parameters being replaced.
   */
  _createClass(InsertQueryBuilder, [{
    key: "getQuery",
    value: function getQuery() {
      var sql = this.createComment();
      sql += this.createCteExpression();
      sql += this.createInsertExpression();
      return sql.trim();
    }
    /**
     * Executes sql generated by query builder and returns raw database results.
     */
  }, {
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2 = this;
        var valueSets, queryRunner, transactionStartedByUs, broadcastResult, declareSql, selectOutputSql, returningResultsEntityUpdator, returningColumns, _iterator, _step, columnPath, _this$getQueryAndPara, _this$getQueryAndPara2, insertSql, parameters, statements, sql, queryResult, insertResult, _broadcastResult;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // console.time(".value sets");
              valueSets = this.getValueSets(); // console.timeEnd(".value sets");
              // If user passed empty array of entities then we don't need to do
              // anything.
              //
              // Fixes GitHub issues #3111 and #5734. If we were to let this through
              // we would run into problems downstream, like subscribers getting
              // invoked with the empty array where they expect an entity, and SQL
              // queries with an empty VALUES clause.
              if (!(valueSets.length === 0)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", new InsertResult());
            case 3:
              // console.time("QueryBuilder.execute");
              // console.time(".database stuff");
              queryRunner = this.obtainQueryRunner();
              transactionStartedByUs = false;
              _context.prev = 5;
              if (!(this.expressionMap.useTransaction === true && queryRunner.isTransactionActive === false)) {
                _context.next = 10;
                break;
              }
              _context.next = 9;
              return queryRunner.startTransaction();
            case 9:
              transactionStartedByUs = true;
            case 10:
              if (!(this.expressionMap.callListeners === true && this.expressionMap.mainAlias.hasMetadata)) {
                _context.next = 15;
                break;
              }
              broadcastResult = new BroadcasterResult();
              valueSets.forEach(function (valueSet) {
                queryRunner.broadcaster.broadcastBeforeInsertEvent(broadcastResult, _this2.expressionMap.mainAlias.metadata, valueSet);
              });
              _context.next = 15;
              return broadcastResult.wait();
            case 15:
              declareSql = null;
              selectOutputSql = null; // if update entity mode is enabled we may need extra columns for the returning statement
              // console.time(".prepare returning statement");
              returningResultsEntityUpdator = new ReturningResultsEntityUpdator(queryRunner, this.expressionMap);
              returningColumns = [];
              if (Array.isArray(this.expressionMap.returning) && this.expressionMap.mainAlias.hasMetadata) {
                _iterator = _createForOfIteratorHelper(this.expressionMap.returning);
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    columnPath = _step.value;
                    returningColumns.push.apply(returningColumns, _toConsumableArray(this.expressionMap.mainAlias.metadata.findColumnsWithPropertyPath(columnPath)));
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              }
              if (this.expressionMap.updateEntity === true && this.expressionMap.mainAlias.hasMetadata) {
                if (!(valueSets.length > 1 && this.connection.driver.options.type === "oracle")) {
                  this.expressionMap.extraReturningColumns = this.expressionMap.mainAlias.metadata.getInsertionReturningColumns();
                }
                returningColumns.push.apply(returningColumns, _toConsumableArray(this.expressionMap.extraReturningColumns.filter(function (c) {
                  return !returningColumns.includes(c);
                })));
              }
              if (returningColumns.length > 0 && this.connection.driver.options.type === "mssql") {
                declareSql = this.connection.driver.buildTableVariableDeclaration("@OutputTable", returningColumns);
                selectOutputSql = "SELECT * FROM @OutputTable";
              }
              // console.timeEnd(".prepare returning statement");
              // execute query
              // console.time(".getting query and parameters");
              _this$getQueryAndPara = this.getQueryAndParameters(), _this$getQueryAndPara2 = _slicedToArray(_this$getQueryAndPara, 2), insertSql = _this$getQueryAndPara2[0], parameters = _this$getQueryAndPara2[1]; // console.timeEnd(".getting query and parameters");
              // console.time(".query execution by database");
              statements = [declareSql, insertSql, selectOutputSql];
              sql = statements.filter(function (s) {
                return s != null;
              }).join(";\n\n");
              _context.next = 27;
              return queryRunner.query(sql, parameters, true);
            case 27:
              queryResult = _context.sent;
              insertResult = InsertResult.from(queryResult); // console.timeEnd(".query execution by database");
              // load returning results and set them to the entity if entity updation is enabled
              if (!(this.expressionMap.updateEntity === true && this.expressionMap.mainAlias.hasMetadata)) {
                _context.next = 32;
                break;
              }
              _context.next = 32;
              return returningResultsEntityUpdator.insert(insertResult, valueSets);
            case 32:
              if (!(this.expressionMap.callListeners === true && this.expressionMap.mainAlias.hasMetadata)) {
                _context.next = 37;
                break;
              }
              _broadcastResult = new BroadcasterResult();
              valueSets.forEach(function (valueSet) {
                queryRunner.broadcaster.broadcastAfterInsertEvent(_broadcastResult, _this2.expressionMap.mainAlias.metadata, valueSet);
              });
              _context.next = 37;
              return _broadcastResult.wait();
            case 37:
              if (!transactionStartedByUs) {
                _context.next = 40;
                break;
              }
              _context.next = 40;
              return queryRunner.commitTransaction();
            case 40:
              return _context.abrupt("return", insertResult);
            case 43:
              _context.prev = 43;
              _context.t0 = _context["catch"](5);
              if (!transactionStartedByUs) {
                _context.next = 53;
                break;
              }
              _context.prev = 46;
              _context.next = 49;
              return queryRunner.rollbackTransaction();
            case 49:
              _context.next = 53;
              break;
            case 51:
              _context.prev = 51;
              _context.t1 = _context["catch"](46);
            case 53:
              throw _context.t0;
            case 54:
              _context.prev = 54;
              if (!(queryRunner !== this.queryRunner)) {
                _context.next = 58;
                break;
              }
              _context.next = 58;
              return queryRunner.release();
            case 58:
              return _context.finish(54);
            case 59:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[5, 43, 54, 59], [46, 51]]);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }() // -------------------------------------------------------------------------
    // Public Methods
    // -------------------------------------------------------------------------
    /**
     * Specifies INTO which entity's table insertion will be executed.
     */
  }, {
    key: "into",
    value: function into(entityTarget, columns) {
      entityTarget = InstanceChecker.isEntitySchema(entityTarget) ? entityTarget.options.name : entityTarget;
      var mainAlias = this.createFromAlias(entityTarget);
      this.expressionMap.setMainAlias(mainAlias);
      this.expressionMap.insertColumns = columns || [];
      return this;
    }
    /**
     * Values needs to be inserted into table.
     */
  }, {
    key: "values",
    value: function values(_values) {
      this.expressionMap.valuesSet = _values;
      return this;
    }
    /**
     * Optional returning/output clause.
     */
  }, {
    key: "output",
    value: function output(_output) {
      return this.returning(_output);
    }
    /**
     * Optional returning/output clause.
     */
  }, {
    key: "returning",
    value: function returning(_returning) {
      // not all databases support returning/output cause
      if (!this.connection.driver.isReturningSqlSupported("insert")) {
        throw new ReturningStatementNotSupportedError();
      }
      this.expressionMap.returning = _returning;
      return this;
    }
    /**
     * Indicates if entity must be updated after insertion operations.
     * This may produce extra query or use RETURNING / OUTPUT statement (depend on database).
     * Enabled by default.
     */
  }, {
    key: "updateEntity",
    value: function updateEntity(enabled) {
      this.expressionMap.updateEntity = enabled;
      return this;
    }
    /**
     * Adds additional ON CONFLICT statement supported in postgres and cockroach.
     *
     * @deprecated Use `orIgnore` or `orUpdate`
     */
  }, {
    key: "onConflict",
    value: function onConflict(statement) {
      this.expressionMap.onConflict = statement;
      return this;
    }
    /**
     * Adds additional ignore statement supported in databases.
     */
  }, {
    key: "orIgnore",
    value: function orIgnore() {
      var statement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.expressionMap.onIgnore = !!statement;
      return this;
    }
    /**
     * Adds additional update statement supported in databases.
     */
  }, {
    key: "orUpdate",
    value: function orUpdate(statementOrOverwrite, conflictTarget, orUpdateOptions) {
      if (!Array.isArray(statementOrOverwrite)) {
        this.expressionMap.onUpdate = {
          conflict: statementOrOverwrite === null || statementOrOverwrite === void 0 ? void 0 : statementOrOverwrite.conflict_target,
          columns: statementOrOverwrite === null || statementOrOverwrite === void 0 ? void 0 : statementOrOverwrite.columns,
          overwrite: statementOrOverwrite === null || statementOrOverwrite === void 0 ? void 0 : statementOrOverwrite.overwrite,
          skipUpdateIfNoValuesChanged: orUpdateOptions === null || orUpdateOptions === void 0 ? void 0 : orUpdateOptions.skipUpdateIfNoValuesChanged
        };
        return this;
      }
      this.expressionMap.onUpdate = {
        overwrite: statementOrOverwrite,
        conflict: conflictTarget,
        skipUpdateIfNoValuesChanged: orUpdateOptions === null || orUpdateOptions === void 0 ? void 0 : orUpdateOptions.skipUpdateIfNoValuesChanged,
        indexPredicate: orUpdateOptions === null || orUpdateOptions === void 0 ? void 0 : orUpdateOptions.indexPredicate
      };
      return this;
    }
    // -------------------------------------------------------------------------
    // Protected Methods
    // -------------------------------------------------------------------------
    /**
     * Creates INSERT express used to perform insert query.
     */
  }, {
    key: "createInsertExpression",
    value: function createInsertExpression() {
      var _this3 = this;
      var tableName = this.getTableName(this.getMainTableName());
      var valuesExpression = this.createValuesExpression(); // its important to get values before returning expression because oracle rely on native parameters and ordering of them is important
      var returningExpression = this.connection.driver.options.type === "oracle" && this.getValueSets().length > 1 ? null : this.createReturningExpression("insert"); // oracle doesnt support returning with multi-row insert
      var columnsExpression = this.createColumnNamesExpression();
      var query = "INSERT ";
      if (DriverUtils.isMySQLFamily(this.connection.driver) || this.connection.driver.options.type === "aurora-mysql") {
        query += "".concat(this.expressionMap.onIgnore ? " IGNORE " : "");
      }
      query += "INTO ".concat(tableName);
      if (this.alias !== this.getMainTableName() && DriverUtils.isPostgresFamily(this.connection.driver)) {
        query += " AS \"".concat(this.alias, "\"");
      }
      // add columns expression
      if (columnsExpression) {
        query += "(".concat(columnsExpression, ")");
      } else {
        if (!valuesExpression && (DriverUtils.isMySQLFamily(this.connection.driver) || this.connection.driver.options.type === "aurora-mysql"))
          // special syntax for mysql DEFAULT VALUES insertion
          query += "()";
      }
      // add OUTPUT expression
      if (returningExpression && this.connection.driver.options.type === "mssql") {
        query += " OUTPUT ".concat(returningExpression);
      }
      // add VALUES expression
      if (valuesExpression) {
        if (this.connection.driver.options.type === "oracle" && this.getValueSets().length > 1) {
          query += " ".concat(valuesExpression);
        } else {
          query += " VALUES ".concat(valuesExpression);
        }
      } else {
        if (DriverUtils.isMySQLFamily(this.connection.driver) || this.connection.driver.options.type === "aurora-mysql") {
          // special syntax for mysql DEFAULT VALUES insertion
          query += " VALUES ()";
        } else {
          query += " DEFAULT VALUES";
        }
      }
      if (this.connection.driver.supportedUpsertType === "on-conflict-do-update") {
        if (this.expressionMap.onIgnore) {
          query += " ON CONFLICT DO NOTHING ";
        } else if (this.expressionMap.onConflict) {
          query += " ON CONFLICT ".concat(this.expressionMap.onConflict, " ");
        } else if (this.expressionMap.onUpdate) {
          var _this$expressionMap$o = this.expressionMap.onUpdate,
            overwrite = _this$expressionMap$o.overwrite,
            columns = _this$expressionMap$o.columns,
            conflict = _this$expressionMap$o.conflict,
            skipUpdateIfNoValuesChanged = _this$expressionMap$o.skipUpdateIfNoValuesChanged,
            indexPredicate = _this$expressionMap$o.indexPredicate;
          var conflictTarget = "ON CONFLICT";
          if (Array.isArray(conflict)) {
            conflictTarget += " ( ".concat(conflict.map(function (column) {
              return _this3.escape(column);
            }).join(", "), " )");
            if (indexPredicate && !DriverUtils.isPostgresFamily(this.connection.driver)) {
              throw new TypeORMError("indexPredicate option is not supported by the current database driver");
            }
            if (indexPredicate && DriverUtils.isPostgresFamily(this.connection.driver)) {
              conflictTarget += " WHERE ( ".concat(this.escape(indexPredicate), " )");
            }
          } else if (conflict) {
            conflictTarget += " ON CONSTRAINT ".concat(this.escape(conflict));
          }
          if (Array.isArray(overwrite)) {
            query += " ".concat(conflictTarget, " DO UPDATE SET ");
            query += overwrite === null || overwrite === void 0 ? void 0 : overwrite.map(function (column) {
              return "".concat(_this3.escape(column), " = EXCLUDED.").concat(_this3.escape(column));
            }).join(", ");
            query += " ";
          } else if (columns) {
            query += " ".concat(conflictTarget, " DO UPDATE SET ");
            query += columns.map(function (column) {
              return "".concat(_this3.escape(column), " = :").concat(column);
            }).join(", ");
            query += " ";
          }
          if (Array.isArray(overwrite) && skipUpdateIfNoValuesChanged && DriverUtils.isPostgresFamily(this.connection.driver)) {
            query += " WHERE (";
            query += overwrite.map(function (column) {
              return "".concat(tableName, ".").concat(_this3.escape(column), " IS DISTINCT FROM EXCLUDED.").concat(_this3.escape(column));
            }).join(" OR ");
            query += ") ";
          }
        }
      } else if (this.connection.driver.supportedUpsertType === "on-duplicate-key-update") {
        if (this.expressionMap.onUpdate) {
          var _this$expressionMap$o2 = this.expressionMap.onUpdate,
            _overwrite = _this$expressionMap$o2.overwrite,
            _columns = _this$expressionMap$o2.columns;
          if (Array.isArray(_overwrite)) {
            query += " ON DUPLICATE KEY UPDATE ";
            query += _overwrite.map(function (column) {
              return "".concat(_this3.escape(column), " = VALUES(").concat(_this3.escape(column), ")");
            }).join(", ");
            query += " ";
          } else if (Array.isArray(_columns)) {
            query += " ON DUPLICATE KEY UPDATE ";
            query += _columns.map(function (column) {
              return "".concat(_this3.escape(column), " = :").concat(column);
            }).join(", ");
            query += " ";
          }
        }
      } else {
        if (this.expressionMap.onUpdate) {
          throw new TypeORMError("onUpdate is not supported by the current database driver");
        }
      }
      // add RETURNING expression
      if (returningExpression && (DriverUtils.isPostgresFamily(this.connection.driver) || this.connection.driver.options.type === "oracle" || this.connection.driver.options.type === "cockroachdb" || DriverUtils.isMySQLFamily(this.connection.driver))) {
        query += " RETURNING ".concat(returningExpression);
      }
      // Inserting a specific value for an auto-increment primary key in mssql requires enabling IDENTITY_INSERT
      // IDENTITY_INSERT can only be enabled for tables where there is an IDENTITY column and only if there is a value to be inserted (i.e. supplying DEFAULT is prohibited if IDENTITY_INSERT is enabled)
      if (this.connection.driver.options.type === "mssql" && this.expressionMap.mainAlias.hasMetadata && this.expressionMap.mainAlias.metadata.columns.filter(function (column) {
        return _this3.expressionMap.insertColumns.length > 0 ? _this3.expressionMap.insertColumns.indexOf(column.propertyPath) !== -1 : column.isInsert;
      }).some(function (column) {
        return _this3.isOverridingAutoIncrementBehavior(column);
      })) {
        query = "SET IDENTITY_INSERT ".concat(tableName, " ON; ").concat(query, "; SET IDENTITY_INSERT ").concat(tableName, " OFF");
      }
      return query;
    }
    /**
     * Gets list of columns where values must be inserted to.
     */
  }, {
    key: "getInsertedColumns",
    value: function getInsertedColumns() {
      var _this4 = this;
      if (!this.expressionMap.mainAlias.hasMetadata) return [];
      return this.expressionMap.mainAlias.metadata.columns.filter(function (column) {
        // if user specified list of columns he wants to insert to, then we filter only them
        if (_this4.expressionMap.insertColumns.length) return _this4.expressionMap.insertColumns.indexOf(column.propertyPath) !== -1;
        // skip columns the user doesn't want included by default
        if (!column.isInsert) {
          return false;
        }
        // if user did not specified such list then return all columns except auto-increment one
        // for Oracle we return auto-increment column as well because Oracle does not support DEFAULT VALUES expression
        if (column.isGenerated && column.generationStrategy === "increment" && !(_this4.connection.driver.options.type === "spanner") && !(_this4.connection.driver.options.type === "oracle") && !DriverUtils.isSQLiteFamily(_this4.connection.driver) && !DriverUtils.isMySQLFamily(_this4.connection.driver) && !(_this4.connection.driver.options.type === "aurora-mysql") && !(_this4.connection.driver.options.type === "mssql" && _this4.isOverridingAutoIncrementBehavior(column))) return false;
        return true;
      });
    }
    /**
     * Creates a columns string where values must be inserted to for INSERT INTO expression.
     */
  }, {
    key: "createColumnNamesExpression",
    value: function createColumnNamesExpression() {
      var _this5 = this;
      var columns = this.getInsertedColumns();
      if (columns.length > 0) return columns.map(function (column) {
        return _this5.escape(column.databaseName);
      }).join(", ");
      // in the case if there are no insert columns specified and table without metadata used
      // we get columns from the inserted value map, in the case if only one inserted map is specified
      if (!this.expressionMap.mainAlias.hasMetadata && !this.expressionMap.insertColumns.length) {
        var valueSets = this.getValueSets();
        if (valueSets.length === 1) return Object.keys(valueSets[0]).map(function (columnName) {
          return _this5.escape(columnName);
        }).join(", ");
      }
      // get a table name and all column database names
      return this.expressionMap.insertColumns.map(function (columnName) {
        return _this5.escape(columnName);
      }).join(", ");
    }
    /**
     * Creates list of values needs to be inserted in the VALUES expression.
     */
  }, {
    key: "createValuesExpression",
    value: function createValuesExpression() {
      var _this6 = this;
      var valueSets = this.getValueSets();
      var columns = this.getInsertedColumns();
      // if column metadatas are given then apply all necessary operations with values
      if (columns.length > 0) {
        var expression = "";
        valueSets.forEach(function (valueSet, valueSetIndex) {
          columns.forEach(function (column, columnIndex) {
            if (columnIndex === 0) {
              if (_this6.connection.driver.options.type === "oracle" && valueSets.length > 1) {
                expression += " SELECT ";
              } else if (_this6.connection.driver.options.type === "sap" && valueSets.length > 1) {
                expression += " SELECT ";
              } else {
                expression += "(";
              }
            }
            // extract real value from the entity
            var value = column.getEntityValue(valueSet);
            // if column is relational and value is an object then get real referenced column value from this object
            // for example column value is { question: { id: 1 } }, value will be equal to { id: 1 }
            // and we extract "1" from this object
            /*if (column.referencedColumn && value instanceof Object && !(typeof value === "function")) { // todo: check if we still need it since getEntityValue already has similar code
                value = column.referencedColumn.getEntityValue(value);
            }*/
            if (!(typeof value === "function")) {
              // make sure our value is normalized by a driver
              value = _this6.connection.driver.preparePersistentValue(value, column);
            }
            // newly inserted entities always have a version equal to 1 (first version)
            // also, user-specified version must be empty
            if (column.isVersion && value === undefined) {
              expression += "1";
              // } else if (column.isNestedSetLeft) {
              //     const tableName = this.connection.driver.escape(column.entityMetadata.tablePath);
              //     const rightColumnName = this.connection.driver.escape(column.entityMetadata.nestedSetRightColumn!.databaseName);
              //     const subQuery = `(SELECT c.max + 1 FROM (SELECT MAX(${rightColumnName}) as max from ${tableName}) c)`;
              //     expression += subQuery;
              //
              // } else if (column.isNestedSetRight) {
              //     const tableName = this.connection.driver.escape(column.entityMetadata.tablePath);
              //     const rightColumnName = this.connection.driver.escape(column.entityMetadata.nestedSetRightColumn!.databaseName);
              //     const subQuery = `(SELECT c.max + 2 FROM (SELECT MAX(${rightColumnName}) as max from ${tableName}) c)`;
              //     expression += subQuery;
            } else if (column.isDiscriminator) {
              expression += _this6.createParameter(_this6.expressionMap.mainAlias.metadata.discriminatorValue);
              // return "1";
              // for create and update dates we insert current date
              // no, we don't do it because this constant is already in "default" value of the column
              // with extended timestamp functionality, like CURRENT_TIMESTAMP(6) for example
              // } else if (column.isCreateDate || column.isUpdateDate) {
              //     return "CURRENT_TIMESTAMP";
              // if column is generated uuid and database does not support its generation and custom generated value was not provided by a user - we generate a new uuid value for insertion
            } else if (column.isGenerated && column.generationStrategy === "uuid" && !_this6.connection.driver.isUUIDGenerationSupported() && value === undefined) {
              value = uuidv4();
              expression += _this6.createParameter(value);
              if (!(valueSetIndex in _this6.expressionMap.locallyGenerated)) {
                _this6.expressionMap.locallyGenerated[valueSetIndex] = {};
              }
              column.setEntityValue(_this6.expressionMap.locallyGenerated[valueSetIndex], value);
              // if value for this column was not provided then insert default value
            } else if (value === undefined) {
              if (_this6.connection.driver.options.type === "oracle" && valueSets.length > 1 || DriverUtils.isSQLiteFamily(_this6.connection.driver) || _this6.connection.driver.options.type === "sap" || _this6.connection.driver.options.type === "spanner") {
                // unfortunately sqlite does not support DEFAULT expression in INSERT queries
                if (column.default !== undefined && column.default !== null) {
                  // try to use default defined in the column
                  expression += _this6.connection.driver.normalizeDefault(column);
                } else {
                  expression += "NULL"; // otherwise simply use NULL and pray if column is nullable
                }
              } else {
                expression += "DEFAULT";
              }
            } else if (value === null && _this6.connection.driver.options.type === "spanner") {
              expression += "NULL";
              // support for SQL expressions in queries
            } else if (typeof value === "function") {
              expression += value();
              // just any other regular value
            } else {
              if (_this6.connection.driver.options.type === "mssql") value = _this6.connection.driver.parametrizeValue(column, value);
              // we need to store array values in a special class to make sure parameter replacement will work correctly
              // if (value instanceof Array)
              //     value = new ArrayParameter(value);
              var paramName = _this6.createParameter(value);
              if ((DriverUtils.isMySQLFamily(_this6.connection.driver) || _this6.connection.driver.options.type === "aurora-mysql") && _this6.connection.driver.spatialTypes.indexOf(column.type) !== -1) {
                var useLegacy = _this6.connection.driver.options.legacySpatialSupport;
                var geomFromText = useLegacy ? "GeomFromText" : "ST_GeomFromText";
                if (column.srid != null) {
                  expression += "".concat(geomFromText, "(").concat(paramName, ", ").concat(column.srid, ")");
                } else {
                  expression += "".concat(geomFromText, "(").concat(paramName, ")");
                }
              } else if (DriverUtils.isPostgresFamily(_this6.connection.driver) && _this6.connection.driver.spatialTypes.indexOf(column.type) !== -1) {
                if (column.srid != null) {
                  expression += "ST_SetSRID(ST_GeomFromGeoJSON(".concat(paramName, "), ").concat(column.srid, ")::").concat(column.type);
                } else {
                  expression += "ST_GeomFromGeoJSON(".concat(paramName, ")::").concat(column.type);
                }
              } else if (_this6.connection.driver.options.type === "mssql" && _this6.connection.driver.spatialTypes.indexOf(column.type) !== -1) {
                expression += column.type + "::STGeomFromText(" + paramName + ", " + (column.srid || "0") + ")";
              } else {
                expression += paramName;
              }
            }
            if (columnIndex === columns.length - 1) {
              if (valueSetIndex === valueSets.length - 1) {
                if (_this6.connection.driver.options.type === "oracle" && valueSets.length > 1) {
                  expression += " FROM DUAL ";
                } else if (_this6.connection.driver.options.type === "sap" && valueSets.length > 1) {
                  expression += " FROM dummy ";
                } else {
                  expression += ")";
                }
              } else {
                if (_this6.connection.driver.options.type === "oracle" && valueSets.length > 1) {
                  expression += " FROM DUAL UNION ALL ";
                } else if (_this6.connection.driver.options.type === "sap" && valueSets.length > 1) {
                  expression += " FROM dummy UNION ALL ";
                } else {
                  expression += "), ";
                }
              }
            } else {
              expression += ", ";
            }
          });
        });
        if (expression === "()") return "";
        return expression;
      } else {
        // for tables without metadata
        // get values needs to be inserted
        var _expression = "";
        valueSets.forEach(function (valueSet, insertionIndex) {
          var columns = Object.keys(valueSet);
          columns.forEach(function (columnName, columnIndex) {
            if (columnIndex === 0) {
              _expression += "(";
            }
            var value = valueSet[columnName];
            // support for SQL expressions in queries
            if (typeof value === "function") {
              _expression += value();
              // if value for this column was not provided then insert default value
            } else if (value === undefined) {
              if (_this6.connection.driver.options.type === "oracle" && valueSets.length > 1 || DriverUtils.isSQLiteFamily(_this6.connection.driver) || _this6.connection.driver.options.type === "sap" || _this6.connection.driver.options.type === "spanner") {
                _expression += "NULL";
              } else {
                _expression += "DEFAULT";
              }
            } else if (value === null && _this6.connection.driver.options.type === "spanner") {
              // just any other regular value
            } else {
              _expression += _this6.createParameter(value);
            }
            if (columnIndex === Object.keys(valueSet).length - 1) {
              if (insertionIndex === valueSets.length - 1) {
                _expression += ")";
              } else {
                _expression += "), ";
              }
            } else {
              _expression += ", ";
            }
          });
        });
        if (_expression === "()") return "";
        return _expression;
      }
    }
    /**
     * Gets array of values need to be inserted into the target table.
     */
  }, {
    key: "getValueSets",
    value: function getValueSets() {
      if (Array.isArray(this.expressionMap.valuesSet)) return this.expressionMap.valuesSet;
      if (ObjectUtils.isObject(this.expressionMap.valuesSet)) return [this.expressionMap.valuesSet];
      throw new InsertValuesMissingError();
    }
    /**
     * Checks if column is an auto-generated primary key, but the current insertion specifies a value for it.
     *
     * @param column
     */
  }, {
    key: "isOverridingAutoIncrementBehavior",
    value: function isOverridingAutoIncrementBehavior(column) {
      return column.isPrimary && column.isGenerated && column.generationStrategy === "increment" && this.getValueSets().some(function (valueSet) {
        return column.getEntityValue(valueSet) !== undefined && column.getEntityValue(valueSet) !== null;
      });
    }
  }]);
  return InsertQueryBuilder;
}(QueryBuilder);